import Home from './Home'
import Login from './Login'
import OneHealthcareIdLogin from './OneHealthcareIdLogin'
import OIDCIdLogin from './OIDCIdLogin'
import OIDCLoginRedirect from './OIDCLoginRedirect'
import LoginRedirect from './LoginRedirect'
import SignOut from './SignOut'
import Profile from './Profile'
import NoAccess from './NoAccess'
import NotFound from './NotFound'
import Dashboard from './Dashboard'
import RSVDashboard from './RSVDashboard'
import RSVStateDashboard from './RSVDashboard/RSVStateDashboard'
import RSVGeoDashboard from './RSVDashboard/RSVGeoDashboard'
import FluDashboard from './FluDashboard'
import FluStateDashboard from './FluDashboard/FluStateDashboard'
import FluZip3Dashboard from './FluDashboard/FluZip3Dashboard'
import FluGeoDashboard from './FluDashboard/FluGeoDashboard'
import CovidDashboard from './CovidDashboard'
import CovidStateDashboard from './CovidDashboard/CovidStateDashboard'
import CovidGeoDashboard from './CovidDashboard/CovidGeoDashboard'
import VulnerabilityDashboard from './VulnerabilityDashboard'
import VulnerabilityStateDashboard from './VulnerabilityDashboard/VulnerabilityStateDashboard'
import VulnerabilityGeoDashboard from './VulnerabilityDashboard/VulnerabilityGeoDashboard'
import VulnerabilityMsaDashboard from './VulnerabilityDashboard/VulnerabilityMsaDashboard'
import AllergiesDashboard from './AllergiesDashboard'
import AllergiesStateDashboard from './AllergiesDashboard/AllergiesStateDashboard'
import AllergiesZip3Dashboard from './AllergiesDashboard/AllergiesZip3Dashboard'
import Registration from './Registration'
import Invitation from './Registration/invitation'
import UnAuthorized from './UnAuthorized'
import AccessAbort from './AccessAbort'
import About from './About'
import FluNewMap from './FluDashboardNew'
import StateRiskMap from './RiskMap/StateRiskMap'
import MSARiskMap from './RiskMap/MSARiskMap'
import RequireAuth from '../components/AuthProvider/RequireAuth'
import ImageGenerate from './ImageGenerate/ImageGenerate'
import StateHeatMapNew from './HeatMapNew/StateHeatMapNew'
import MSAHeatMapNew from './HeatMapNew/MSAHeatMapNew'
import PrivacyPolicy from './PrivacyPolicyAndTermsofUse/PrivacyPolicy'
import TermsofUse from './PrivacyPolicyAndTermsofUse/TermsofUse'
import BirthTrendDashboard from './BirthTrendDashboard'
import BirthTrendStateDashboard from './BirthTrendDashboard/BirthTrendStateDashboard'
import BirthTrendCountyDashboard from './BirthTrendDashboard/BirthTrendCountyDashboard'
import Flumeter from './Flumeter'
import MeningitisDashboard from './Meningitis'
import UTIDashboard from './UTIDashboard'
import UTIStateDashboard from './UTIDashboard/UTIStateDashboard'
import UTIMSADashboard from './UTIDashboard/UTIMSADashboard'
import UTIZip3Dashboard from './UTIDashboard/UTIZip3Dashboard'
import RareDiseaseDashboard from './RareDiseaseDashboard'
import SurveillanceDashboard from './SurveillanceDashboard'
import VaccinationDashboard from './VaccinationDashboard'
import ActiveDirectoryLoginRedirect from './ActiveDirectoryLoginRedirect'
import FluVaccination from './FluVaccination'
import FluVaccinationDetails from './FluVaccinationDetails'
import ShinglesDashboard from './Shingles'
import FlumeterRedirect from './flumeter1'

const adminAccounts = ['Admin']
const externalAccount = ['External']
const otherAccounts = ['Basic', 'Power User']
const allAccounts = [...otherAccounts, ...adminAccounts, ...externalAccount]
const restrictAccounts = ['Admin', 'Basic', 'Power User']
const allEnvironments = ['local', 'dev', 'stage', 'prod']
const nonProdEnvironments = ['local', 'dev', 'stage']


const dashboardRoutes = [ {
  authorizedRoles: allAccounts,
  envAccess: allEnvironments,
  element: <Home />,
  label: 'home',
  path: '/',
  dashboardAccess: 'home',
  routes: [
    {
      isHidden: true,
      authorizedRoles: allAccounts,
      envAccess: allEnvironments,
      element: (
        <RequireAuth dashboardAccess={'profile'}>
          <Profile />
        </RequireAuth>
      ),
      path: '/profile',
      dashboardAccess: 'profile',
      routes: [],
    },
   
   {
        authorizedRoles: adminAccounts,
        envAccess: allEnvironments,
        element: (
            <RequireAuth dashboardAccess={'vaccinations'}>
              <FluVaccination />
            </RequireAuth>
          ),
        
        label: 'Vaccinations',
        path: '/vaccinations',
      
        routes: [
          {
            isHidden: true,
            authorizedRoles: adminAccounts,
            envAccess: allEnvironments,
            element: (
            <RequireAuth dashboardAccess={'fluvaccination'}>
              <FluVaccination />
            </RequireAuth>
          ),
            path: '/fluvaccination',
            routes: [],
          },
          {
            isHidden: true,
            authorizedRoles: adminAccounts,
            envAccess: allEnvironments,
            element: (
            <RequireAuth dashboardAccess={'fluvaccination'}>
              <FluVaccinationDetails />
            </RequireAuth>
          ),
            label: 'Flu Vaccination Details',
            path: ':area',
          },
        ],
      },
   
    {
      isHidden: true,
      authorizedRoles: allAccounts,
      envAccess: allEnvironments,
      element: (
        <RequireAuth dashboardAccess={'about'}>
          <About />
        </RequireAuth>
      ),
      path: '/about',
      dashboardAccess: 'about',
      routes: [],
    },

    {
      isHidden: true,
      authorizedRoles: allAccounts,
      envAccess: allEnvironments,
      element: (
        <RequireAuth dashboardAccess={'flunewmap'}>
          <FluNewMap />
        </RequireAuth>
      ),
      path: '/flunew',
      routes: [],
    },
    {
      isHidden: true,
      authorizedRoles: allAccounts,
      envAccess: allEnvironments,
      element: (
        <RequireAuth dashboardAccess={'dashboard'}>
          <Dashboard />
        </RequireAuth>
      ),
      label: '',
      path: '/dashboard',
      routes: [],
    },
    {
      isHidden: true,
      authorizedRoles: allAccounts,
      envAccess: allEnvironments,
      element: (
        <RequireAuth   dashboardAccess={'rsvdashboard'}>
          <RSVDashboard />
        </RequireAuth>
      ),

      label: '',
      path: '/rsvdashboard',
      routes: [],
    },
    {
      isHidden: true,
      authorizedRoles: allAccounts,
      envAccess: allEnvironments,
      element: (
        <RequireAuth dashboardAccess={'heatmap'}>
          <StateRiskMap />
        </RequireAuth>
      ),
      label: '',
      path: '/HeatMap/:diseaseType/NAT',
      routes: [],
    },
    {
      isHidden: true,
      authorizedRoles: allAccounts,
      envAccess: allEnvironments,
      element: (
        <RequireAuth dashboardAccess={'heatmap'}>
          <MSARiskMap />
        </RequireAuth>
      ),
      label: '',
      path: '/HeatMap/:diseaseType/state/:geoId',
      routes: [],
    },
    {
      isHidden: true,
      authorizedRoles: allAccounts,
      envAccess: allEnvironments,
      element: (
        <RequireAuth dashboardAccess={'heatmap'}>
          <StateHeatMapNew />
        </RequireAuth>
      ),
      label: '',
      path: '/HeatMapNew/:diseaseType/NAT',
      routes: [],
    },
    {
      isHidden: true,
      authorizedRoles: allAccounts,
      envAccess: allEnvironments,
      element: (
        <RequireAuth dashboardAccess={'heatmap'}>
          <MSAHeatMapNew />
        </RequireAuth>
      ),
      label: '',
      path: '/HeatMapNew/:diseaseType/state/:geoId',
      routes: [],
    },

    {
      isHidden: true,
      authorizedRoles: allAccounts,
      envAccess: allEnvironments,
      element: (
        <RequireAuth dashboardAccess={'rsvdashboard'}>
          <RSVDashboard />
        </RequireAuth>
      ),
      label: 'RSVDashboard',
      path: '/rsvstatedashboard',
      routes: [
        {
          isHidden: true,
          authorizedRoles: allAccounts,
          envAccess: allEnvironments,
          element: (
            <RequireAuth dashboardAccess={'rsvdashboard'}>
              <RSVStateDashboard />
            </RequireAuth>
          ),

          label: 'State View',
          path: ':area/:loc',
        },
      ],
    },
    {
      isHidden: true,
      authorizedRoles: allAccounts,
      envAccess: allEnvironments,
      element: (
        <RequireAuth dashboardAccess={'rsvdashboard'}>
          <RSVDashboard />
        </RequireAuth>
      ),

      label: 'rsvdashboard',
      path: '/rsvmsadashboard',

      routes: [
        {
          isHidden: true,
          authorizedRoles: allAccounts,
          envAccess: allEnvironments,
          element: (
            <RequireAuth dashboardAccess={'rsvdashboard'}>
              <RSVGeoDashboard />
            </RequireAuth>
          ),
          label: 'MSA View',
          path: ':geo_parent/:area/:loc',
        },
      ],
    },

    {
      isHidden: true,
      authorizedRoles: allAccounts,
      envAccess: allEnvironments,
      element: (
        <RequireAuth dashboardAccess={'fludashboard'}>
          <FluDashboard />
        </RequireAuth>
      ),
      label: '',
      path: '/fludashboard',
      routes: [],
    },

    {
      isHidden: true,
      authorizedRoles: allAccounts,
      envAccess: allEnvironments,
      element: (
        <RequireAuth dashboardAccess={'fludashboard'}>
          <FluDashboard />
        </RequireAuth>
      ),
      label: 'fludashboard',
      path: '/flustatedashboard',
      routes: [
        {
          isHidden: true,
          authorizedRoles: allAccounts,
          envAccess: allEnvironments,
          element: (
            <RequireAuth dashboardAccess={'fludashboard'}>
              <FluStateDashboard />
            </RequireAuth>
          ),
          label: 'State View',
          path: ':area/:loc',
        },
      ],
    },

    {
      isHidden: true,
      authorizedRoles: allAccounts,
      envAccess: allEnvironments,
      element: (
        <RequireAuth dashboardAccess={'fludashboard'}>
          <FluDashboard />
        </RequireAuth>
      ),
      label: 'fludashboard',
      path: '/flumsadashboard',

      routes: [
        {
          isHidden: true,
          authorizedRoles: allAccounts,
          envAccess: allEnvironments,
          element: (
            <RequireAuth dashboardAccess={'fludashboard'}>
              <FluGeoDashboard />
            </RequireAuth>
          ),
          label: 'MSA View',
          path: ':geo_parent/:area/:loc',
        },
      ],
    },

    {
      isHidden: true,
      authorizedRoles: allAccounts,
      envAccess: allEnvironments,
      element: (
        <RequireAuth dashboardAccess={'fludashboard'}>
          <FluZip3Dashboard />
        </RequireAuth>
      ),
      label: 'FLUZIP3Dashboard',
      path: '/fluzip3dashboard',
      routes: [
        {
          isHidden: true,
          authorizedRoles: allAccounts,
          envAccess: allEnvironments,
          element: (
            <RequireAuth dashboardAccess={'fludashboard'}>
              <FluZip3Dashboard />
            </RequireAuth>
          ),
          label: 'MSA View',
          path: ':geo_parent/:area/:loc?',
        },
      ],
    },

    {
      isHidden: true,
      authorizedRoles: allAccounts,
      envAccess: allEnvironments,
      element: (
        <RequireAuth dashboardAccess={'coviddashboard'}>
          <CovidDashboard />
        </RequireAuth>
      ),
      label: '',
      path: '/coviddashboard',
      routes: [],
    },
    {
      isHidden: true,
      authorizedRoles: allAccounts,
      envAccess: allEnvironments,
      element: (
        <RequireAuth dashboardAccess={'coviddashboard'}>
          <CovidDashboard />
        </RequireAuth>
      ),
      label: 'coviddashboard',
      path: '/covidstatedashboard',
      routes: [
        {
          isHidden: true,
          authorizedRoles: allAccounts,
          envAccess: allEnvironments,
          element: (
            <RequireAuth dashboardAccess={'coviddashboard'}>
              <CovidStateDashboard />
            </RequireAuth>
          ),
          label: 'State View',
          path: ':area/:loc',
        },
      ],
    },
    {
      isHidden: true,
      authorizedRoles: allAccounts,
      envAccess: allEnvironments,
      element: (
        <RequireAuth dashboardAccess={'coviddashboard'}>
          <CovidDashboard />
        </RequireAuth>
      ),
      label: 'coviddashboard',
      path: '/covidmsadashboard',

      routes: [
        {
          isHidden: true,
          authorizedRoles: allAccounts,
          envAccess: allEnvironments,
          element: (
            <RequireAuth dashboardAccess={'coviddashboard'}>
              <CovidGeoDashboard />
            </RequireAuth>
          ),
          label: 'MSA View',
          path: ':geo_parent/:area/:loc',
        },
      ],
    },

    {
      isHidden: true,
      authorizedRoles: restrictAccounts,
      envAccess: allEnvironments,
      element: (
        <RequireAuth dashboardAccess={'vulnerabilitydashboard'} restrictAccounts={restrictAccounts}>
          <VulnerabilityDashboard />
        </RequireAuth>
      ),
      label: '',
      path: '/vulnerabilitydashboard',
      routes: [],
    },
    {
      isHidden: true,
      authorizedRoles: restrictAccounts,
      envAccess: allEnvironments,
      element: (
        <RequireAuth dashboardAccess={'vulnerabilitydashboard'} restrictAccounts={restrictAccounts}>
          <VulnerabilityDashboard />
        </RequireAuth>
      ),
      label: 'vulnerabilitydashboard',
      path: '/VulnerabilityStateDashboard',
      routes: [
        {
          isHidden: true,
          authorizedRoles: restrictAccounts,
          envAccess: allEnvironments,
          element: (
            <RequireAuth dashboardAccess={'vulnerabilitydashboard'} restrictAccounts={restrictAccounts}>
              <VulnerabilityStateDashboard />
            </RequireAuth>
          ),

          label: 'State View',
          path: ':area/:loc',
        },
      ],
    },
    {
      isHidden: true,
      authorizedRoles: restrictAccounts,
      envAccess: allEnvironments,
      element: (
        <RequireAuth dashboardAccess={'vulnerabilitydashboard'} restrictAccounts={restrictAccounts}>
          <VulnerabilityDashboard />
        </RequireAuth>
      ),
      label: 'vulnerabilitydashboard',
      path: '/vulnerabilitygeodashboard',

      routes: [
        {
          isHidden: true,
          authorizedRoles: restrictAccounts,
          envAccess: allEnvironments,
          element: (
            <RequireAuth dashboardAccess={'vulnerabilitydashboard'} restrictAccounts={restrictAccounts}>
              <VulnerabilityGeoDashboard />
            </RequireAuth>
          ),

          label: 'MSA View',
          path: ':geo_parent/:area/:loc',
        },
      ],
    },
    {
      isHidden: true,
      authorizedRoles: restrictAccounts,
      envAccess: allEnvironments,
      element: (
        <RequireAuth dashboardAccess={'vulnerabilitydashboard'} restrictAccounts={restrictAccounts}>
          <VulnerabilityDashboard />
        </RequireAuth>
      ),

      label: 'vulnerabilitydashboard',
      path: '/vulnerabilitymsadashboard',

      routes: [
        {
          isHidden: true,
          authorizedRoles: restrictAccounts,
          envAccess: allEnvironments,
          element: (
            <RequireAuth dashboardAccess={'vulnerabilitydashboard'} restrictAccounts={restrictAccounts}>
              <VulnerabilityMsaDashboard />
            </RequireAuth>
          ),

          label: 'MSA View',
          path: ':geo_parent/:area/:loc',
        },
      ],
    },
    {
      isHidden: true,
      authorizedRoles: allAccounts,
      envAccess: allEnvironments,
      element: (
        <RequireAuth dashboardAccess={'allergiesdashboard'}>
          <AllergiesDashboard />
        </RequireAuth>
      ),
      //component: requiresAuth(AllergiesDashboard),
      label: '',
      path: '/allergiesdashboard',
      dashboardAccess: 'allergiesdashboard',
      routes: [],
    },
    {
      isHidden: true,
      authorizedRoles: allAccounts,
      envAccess: allEnvironments,
      element: (
        <RequireAuth dashboardAccess={'allergiesdashboard'}>
          <AllergiesDashboard />
        </RequireAuth>
      ),
      //component: requiresAuth(AllergiesDashboard),
      label: 'allergiesdashboard',
      path: '/allergiesstatedashboard',
      dashboardAccess: 'allergiesdashboard',
      routes: [
        {
          isHidden: true,
          authorizedRoles: allAccounts,
          envAccess: allEnvironments,
          element: (
            <RequireAuth dashboardAccess={'allergiesdashboard'}>
              <AllergiesStateDashboard />
            </RequireAuth>
          ),
          // component: requiresAuth(
          //   AllergiesStateDashboard,
          //   restrictAccounts
          // ),
          label: 'State View',
          path: ':area/:loc',
          dashboardAccess: 'allergiesdashboard',
        },
      ],
    },
    {
      isHidden: true,
      authorizedRoles: allAccounts,
      envAccess: allEnvironments,
      element: (
        <RequireAuth dashboardAccess={'allergiesdashboard'}>
          <AllergiesZip3Dashboard />
        </RequireAuth>
      ),
      //component: requiresAuth(AllergiesZip3Dashboard),
      label: 'allergieszip3dashboard',
      path: '/allergieszip3dashboard',
      dashboardAccess: 'allergiesdashboard',
      routes: [
        {
          isHidden: true,
          authorizedRoles: allAccounts,
          envAccess: allEnvironments,
          element: (
            <RequireAuth dashboardAccess={'allergiesdashboard'}>
              <AllergiesZip3Dashboard />
            </RequireAuth>
          ),
          //component: requiresAuth(AllergiesZip3Dashboard),
          label: 'MSA View',
          path: ':geo_parent/:area/:loc?',
          dashboardAccess: 'allergiesdashboard',
        },
      ],
    },
    {
      isHidden: true,
      authorizedRoles: allAccounts,
      envAccess: allEnvironments,
      element: (
        <RequireAuth dashboardAccess={'vaccinationdashboard'}>
          <VaccinationDashboard />
        </RequireAuth>
      ),
      //component: requiresAuth(VaccinationDashboard),
      label: '',
      path: '/vaccinationdashboard',
      dashboardAccess: 'vaccinationdashboard',
      routes: [],
    },
    {
      isHidden: true,
      authorizedRoles: allAccounts,
      envAccess: allEnvironments,
      element: (
        <RequireAuth dashboardAccess={'rarediseasedashboard'}>
          <RareDiseaseDashboard />
        </RequireAuth>
      ),
      //component: requiresAuth(RareDiseaseDashboard),
      label: '',
      path: '/rarediseasedashboard',
      dashboardAccess: 'rarediseasedashboard',
      routes: [],
    },
     {
      isHidden: true,
      authorizedRoles: allAccounts,
      envAccess: allEnvironments,
      element: (
        <RequireAuth dashboardAccess={'surveillancedashboard'}>
          <SurveillanceDashboard />
        </RequireAuth>
      ),
      //component: requiresAuth(SurveillanceDashboard),
      label: '',
      path: '/surveillancedashboard',
      dashboardAccess: 'surveillancedashboard',
      routes: [],
    },
     {
      isHidden: true,
      authorizedRoles: restrictAccounts,
      envAccess: allEnvironments,
      element: (
        <RequireAuth dashboardAccess={'meningitisdashboard'} restrictAccounts={restrictAccounts}>
          <MeningitisDashboard />
        </RequireAuth>
      ),
      label: '',
      path: '/meningitisdashboard',
      routes: [],
    },
    { 
          isHidden: true,
          authorizedRoles: restrictAccounts,
          envAccess: allEnvironments,
          element: (
            <RequireAuth dashboardAccess={'utidashboard'} restrictAccounts={restrictAccounts}>
              <UTIDashboard />
            </RequireAuth>
          ),
            label: '',
            path: '/utidashboard',
            routes: [],
    },
    {
        isHidden: true,
        authorizedRoles: restrictAccounts,
        envAccess: allEnvironments,
        element: (
            <RequireAuth dashboardAccess={'utidashboard'} restrictAccounts={restrictAccounts}>
              <UTIDashboard />
            </RequireAuth>
          ),
        label: 'UtiStateDashboard',
        path: '/utistatedashboard',
        routes: [
          {
            isHidden: true,
            authorizedRoles: restrictAccounts,
            envAccess: allEnvironments,
            element: (
            <RequireAuth dashboardAccess={'utidashboard'} restrictAccounts={restrictAccounts}>
              <UTIStateDashboard />
            </RequireAuth>
          ),
            label: 'State View',
            path: ':area/:loc',
          },
        ],
    },   
    {
        isHidden: true,
        authorizedRoles: allAccounts,
        envAccess: allEnvironments,
        element: (
            <RequireAuth dashboardAccess={'utidashboard'} restrictAccounts={restrictAccounts}>
              <UTIDashboard />
            </RequireAuth>
          ),
        label: 'UTIMSADashboard',
        path: '/utimsadashboard',
        routes: [
          {
            isHidden: true,
            authorizedRoles: allAccounts,
            envAccess: allEnvironments,
            element: (
              <RequireAuth dashboardAccess={'utidashboard'} restrictAccounts={restrictAccounts}>
                <UTIMSADashboard />
              </RequireAuth>
            ),
            label: 'MSA View',
            path: ':geo_parent/:area/:loc',
          },
        ],
    },   
    {
        isHidden: true,
        authorizedRoles: allAccounts,
        envAccess: allEnvironments,
       element: (
            <RequireAuth dashboardAccess={'utidashboard'} restrictAccounts={restrictAccounts}>
              <UTIDashboard />
            </RequireAuth>
          ),
        label: 'UTIZip3Dashboard',
        path: '/utizip3dashboard',
        routes: [
          {
            isHidden: true,
            authorizedRoles: allAccounts,
            envAccess: allEnvironments,
            element: (
              <RequireAuth dashboardAccess={'utidashboard'} restrictAccounts={restrictAccounts}>
                <UTIZip3Dashboard />
              </RequireAuth>
            ),
            label: 'Zip View',
            path: ':geo_parent/:area/:loc',
          },
        ],
    },
    {
      isHidden: true,
      authorizedRoles: restrictAccounts,
      envAccess: allEnvironments,
      element: (
        <RequireAuth dashboardAccess={'shinglesdashboard'} restrictAccounts={restrictAccounts}>
          <ShinglesDashboard />
        </RequireAuth>
      ),
      label: '',
      path: '/shinglesdashboard',
      routes: [],
    },
  ],
},
{
  isHidden: true,
  authorizedRoles: restrictAccounts,
  envAccess: allEnvironments,
  element: (
    <RequireAuth dashboardAccess={'birthtrenddashboard'} restrictAccounts={restrictAccounts}>
      <BirthTrendDashboard />
    </RequireAuth>
  ),
  label: '',
  path: '/birthtrenddashboard',
  routes: [],
},
{
  isHidden: true,
  authorizedRoles: restrictAccounts,
  envAccess: allEnvironments,
  element: (
    <RequireAuth dashboardAccess={'birthtrenddashboard'} restrictAccounts={restrictAccounts}>
      <BirthTrendDashboard />
    </RequireAuth>
  ),
  label: 'BirthTrendDashboard',
  path: '/birthtrendstatedashboard',
  routes: [
    {
      isHidden: true,
      authorizedRoles: restrictAccounts,
      envAccess: allEnvironments,
      element: (
        <RequireAuth dashboardAccess={'birthtrenddashboard'} restrictAccounts={restrictAccounts}>
          <BirthTrendStateDashboard />
        </RequireAuth>
      ),

      label: 'State View',
      path: ':area/:loc',
    },
  ],
},
{
  isHidden: true,
  authorizedRoles: restrictAccounts,
  envAccess: allEnvironments,
  element: (
    <RequireAuth dashboardAccess={'birthtrenddashboard'} restrictAccounts={restrictAccounts}>
      <BirthTrendDashboard />
    </RequireAuth>
  ),
  label: 'BirthTrendDashboard',
  path: '/birthtrendcountydashboard',

  routes: [
    {
      isHidden: true,
      authorizedRoles: restrictAccounts,
      envAccess: allEnvironments,
      element: (
        <RequireAuth dashboardAccess={'birthtrenddashboard'} restrictAccounts={restrictAccounts}>
          <BirthTrendCountyDashboard />
        </RequireAuth>
      ),

      label: 'County View',
      path: ':geo_parent/:area/:loc',
    },
  ],
},

{
  authorizedRoles: allAccounts,
  envAccess: nonProdEnvironments,
  element: (
    <RequireAuth dashboardAccess={'imagegenerate'} env={nonProdEnvironments}>
      <ImageGenerate />
    </RequireAuth>
  ),
  path: '/image-generate',
},


]
const authRoutes = [ {
  authorizedRoles: allAccounts,
  envAccess: allEnvironments,
  element: <OneHealthcareIdLogin />,
  path: '/ohid-login',
},
  {
    authorizedRoles: allAccounts,
    envAccess: allEnvironments,
    element: <OIDCIdLogin/>,
    path: '/sso-login',
  },
   {
    authorizedRoles: allAccounts,
    envAccess: allEnvironments,
    element: <OIDCLoginRedirect/>,
    path: '/oidc-login',
  },
    {
    authorizedRoles: allAccounts,
    envAccess: allEnvironments,
    element: <ActiveDirectoryLoginRedirect />,
    path: '/msid/login-redirect',
  },
{
  authorizedRoles: allAccounts,
  envAccess: allEnvironments,
  element: <Login />,
  path: '/login',
},
{
  authorizedRoles: allAccounts,
  envAccess: allEnvironments,
  element: <LoginRedirect />,
  path: '/oauth2/login-redirect',
},
{
  authorizedRoles: allAccounts,
  envAccess: allEnvironments,
  element: <SignOut />,
  path: '/signout',
},

{
  authorizedRoles: allAccounts,
  envAccess: allEnvironments,
  element: <Registration />,
  path: '/registration',
},
{
  // authorizedRoles: allAccounts,
  // envAccess: allEnvironments,
  // element: <Flumeter />,
  // path: '/flumeter',
  authorizedRoles: allAccounts,
  envAccess: nonProdEnvironments,
  element: (
    
      <Flumeter />
   
  ),
  path: '/flumeter',
},
{
  authorizedRoles: allAccounts,
  envAccess: nonProdEnvironments,
  path: "/flumeter1",
  element: <FlumeterRedirect />,
},
{
  authorizedRoles: allAccounts,
  envAccess: allEnvironments,
  element: (
    <RequireAuth dashboardAccess={'invitation'}>
      <Invitation />
    </RequireAuth>
  ),

  path: '/invitation',
},
]
 const errorRoutes = [
  {
    authorizedRoles: allAccounts,
    envAccess: allEnvironments,
    element: <NoAccess />,
    path: '/access-denied',
  },
  {
    authorizedRoles: allAccounts,
    envAccess: allEnvironments,
    element: <UnAuthorized />,
    path: '/unauthorized',
  },
  {
    authorizedRoles: allAccounts,
    envAccess: allEnvironments,
    element: <AccessAbort />,
    path: '/accessabort',
  },
  {
    authorizedRoles: allAccounts,
    envAccess: allEnvironments,
    element: <NotFound />,
    path: '*',
  },
]

const policyRoutes = [
  {
    authorizedRoles: allAccounts,
    envAccess: allEnvironments,
    element: <PrivacyPolicy />,
    path: '/privacy-policy',
  },
  {
    authorizedRoles: allAccounts,
    envAccess: allEnvironments,
    element: <TermsofUse />,
    path: '/terms-of-use'
  }
];


const Pages = [
  ...dashboardRoutes,
  ...authRoutes,
  ...errorRoutes,
  ...policyRoutes,
];


export default Pages